import BaseService from '../base/baseService';

class commonService extends BaseService {
  upload2Qiniu({ fileName, data }) {
    if(this.isVisitor) {
      this.confirmLogin();
      return Promise.reject({});
    }
    return this.post('/common/file/upload', { fileName, data })
  }

  getUserInfo({ userId }) {
    return this.post('/accounts/mobile/base/info', { userId, areaCode: 'NXT', companyCode: 'NXT-GS' })
  }

  getCollections({ userId, areaCode, pageNum, pageSize }) {
    return this.post('/accounts/collection/query',  { userId, areaCode, pageNum, pageSize })
  }

  getInfoList() {
    return this.$http.post('/query/common/city/list', { areaCode: 'NXT', companyCode: 'NXT-GS' })
  }

  report({ code, type, userId }) {
    return this.post('/common/up/reported', { code, type, userId, areaCode: 'NXT', companyCode: 'NXT-GS' })
  }

  

  getJsTiket(encrypt) {
    return this.post('/mpapi',{
			guid:'web',
			platform:'web',
			version:'1.2.2',
			time: parseInt(+new Date()/1000),
			encrypt: encrypt,
			reqs:[{
				head:{cmd:'jsapi_signature',srv:'wxaccess_wxauth'},
				body:{appId:'wx127bc8f367c5afae',url:location.href.split('#')[0]}
			}]
    },
    {
      baseURL: '/',
    })
  }

  saveUserInfo({
    userId,
    userName,
    nickName,
    cityCode,
    cityName,
    hospitalName,
    departmentCode,
    departmentName,
    positionCode,
    positionName,
    email
  }) {
    return this.post('/accounts/mobile/realname', {
      userId,
      userName,
      nickName,
      cityCode,
      cityName,
      hospitalName,
      departmentCode,
      departmentName,
      positionCode,
      positionName,
      email,
      companyCode: 'NXT-GS',
      areaCode: 'NXT'
    })
  }

  loginSetInfo({ userId, nickName, password }) {
    return this.post('/accounts/login/set/password', {
      userId,
      nickName,
      password,
      companyCode: 'NXT-GS',
      areaCode: 'NXT'
    })
  }

  saveUserPic({ areaCode, companyCode, userId, healthCarePhotoUrl, healthCarePersonalUrl, badgePhotoUrl, idCardUrl }) {
    return this.post('/accounts/mobile/save', {
      areaCode, companyCode, userId, healthCarePhotoUrl, healthCarePersonalUrl, badgePhotoUrl, idCardUrl
    })
  }

  resetPassword ({ password, userId }) {
    return this.post('/accounts/login/set/password', { password, userId })
  }

  getHospitalList ({ id, name }) {
    return this.post('/query/hospital/list/v2', { id, name, areaCode: "NXT", companyCode: "NXT-GS", })
  }

  shareReport({ type, shareEncrypt }) {
    return this.post('/share/report', { type, shareEncryptKey: shareEncrypt  })
  }

  timeReport({ code, userId, type, logType, viewId }) {
    if(this.isVisitor) {
      userId = ''
    }
    return this.post('/common/report/time/save', { companyCode:'NXT-GS', areaCode:'NXT', code, userId, type, logType, viewId })
  }

  pageSaveReport({ UserID, Access, PageID, PageName, EventID, Description, ActionType, ActionObj }) {
      /**
      *  埋点上报接口服务   from Min in 2018/8/13
      *  UserID用户id            用户userId
      *  Access访问来源          其值为进入专区首页链接地址拿到的 Access 参数
      *  DeviceTime             获取当前时间戳
      *  CompanyCode/AreaCode   公司code/专区code
      *  PageID/PageName        页面id/name    1、首页  2、前沿资讯  3、精选病例  4、百家讲坛  5、我的收藏   6、搜索页面
                                              7、文章详情    8、视频详情  9、会议详情  10、病例详情  11、外链  12、详情评论页
      *  EventID 事件id         事件id         1、页面加载事件 onload   2、点击事件 onclick
      *  Description            描述           首页访问来源埋点/ 全点击事件埋点
      *  ActionType             动作类型       1、首页访问来源埋点      2、全点击事件埋点
      *  ActionName             动作名         pv
      *  ActionObj              动作对象       主要阵对点击事件，页面加载事件给''
      *  AppVersion/ MobileModel/MobileSystemModel  获取设备信息
      */
    return this.post('/common/report/page/save', { UserID, Access, DeviceTime: new Date(), DeviceID: '', InviteUserID: '', CompanyCode: 'YP-GS', AreaCode: 'YP', PageID, PageName, EventID, ControlID: '', ControlName: '', Description,
        ActionType, ActionName:'pv', ClientIP: '', Browser: '', ActionObj, AppVersion: navigator.appVersion, MobileModel: navigator.appVersion, MobileSystemModel: navigator.appVersion })
    }

  outLinkReport({ url, type }) {
    return this.post('/common/report/pv/add', { url, type })
  }

}

export default new commonService();



// WEBPACK FOOTER //
// ./src/common/service/commonService.js